const TwoFActionTypes = {
    STATUS_CHANGE_OF_2FA: 'STATUS_CHANGE_OF_2FA',
    SET_2FA_TYPE: 'SET_2FA_TYPE',
    FAILURE_2FA: 'FAILURE_2FA',

    START_CHANGE_2FA_AUTHENTICATION_TYPE: 'START_CHANGE_2FA_AUTHENTICATION_TYPE',
    VERIFY_GOOGLE_AUTH_CODE: 'VERIFY_GOOGLE_AUTH_CODE',
    SUCCESS_CHANGE_2FA_AUTHENTICATION_TYPE: 'SUCCESS_CHANGE_2FA_AUTHENTICATION_TYPE',
    FINISH_CHANGE_2FA_AUTHENTICATION_TYPE: 'FINISH_CHANGE_2FA_AUTHENTICATION_TYPE',
    FAILURE_CHANGE_2FA_AUTHENTICATION_TYPE: 'FAILURE_CHANGE_2FA_AUTHENTICATION_TYPE',

    START_GOOGLE_AUTHENTICATION_SETUP: 'START_GOOGLE_AUTHENTICATION_SETUP',
    SUCCESS_GOOGLE_AUTHENTICATION_SETUP: 'SUCCESS_GOOGLE_AUTHENTICATION_SETUP',
    FINISH_GOOGLE_AUTHENTICATION_SETUP: 'FINISH_GOOGLE_AUTHENTICATION_SETUP',
    FAILURE_GOOGLE_AUTHENTICATION_SETUP: 'FAILURE_GOOGLE_AUTHENTICATION_SETUP',

    START_GOOGLE_AUTHENTICATION_VERIFY: 'START_GOOGLE_AUTHENTICATION_VERIFY',
    SUCCESS_GOOGLE_AUTHENTICATION_VERIFY: 'SUCCESS_GOOGLE_AUTHENTICATION_VERIFY',
    FINISH_GOOGLE_AUTHENTICATION_VERIFY: 'FINISH_GOOGLE_AUTHENTICATION_VERIFY',
    FAILURE_GOOGLE_AUTHENTICATION_VERIFY: 'FAILURE_GOOGLE_AUTHENTICATION_VERIFY',

    START_FETCH_AUTHENTICATION_TYPES: 'START_FETCH_AUTHENTICATION_TYPES',
    SUCCESS_FETCH_AUTHENTICATION_TYPES: 'SUCCESS_FETCH_AUTHENTICATION_TYPES',
    FINISH_FETCH_AUTHENTICATION_TYPES: 'FINISH_FETCH_AUTHENTICATION_TYPES',
    FAILURE_FETCH_AUTHENTICATION_TYPES: 'FAILURE_FETCH_AUTHENTICATION_TYPES',
}

export default TwoFActionTypes
